import { render, staticRenderFns } from "./ipList.vue?vue&type=template&id=29ede02e&"
import script from "./ipList.vue?vue&type=script&lang=js&"
export * from "./ipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports